import { LinkAuthMethodStrategy } from './link-auth-method-strategy.inteface';
import { AuthMethod } from '../../../account-window/parts/auth-method';
import { HubApi } from '@scorewarrior/rubens_web_lib/lib/hub-api/hub-api';
import {
    LinkAuthMethodAppleIdRequest,
    LinkAuthMethodAppleIdResponse
} from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/link-auth-method-apple-id.protocol';

export class LinkAuthMethodAppleIdStrategy implements LinkAuthMethodStrategy {
    static authMethod = AuthMethod.APPLE_ID;
    constructor(private hubApi: HubApi) {}

    link(deviceId: string, params: LinkAuthMethodAppleIdRequest): Promise<LinkAuthMethodAppleIdResponse> {
        return this.hubApi.linkAuthMethodAppleId(deviceId, params);
    }
}
